module.exports = {
  "zones": {
    "Indian/Reunion": ["z", {
      "wallclock": -1848873600000,
      "format": "+04",
      "abbrev": "+04",
      "offset": 14400000,
      "posix": -1848886912000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 13312000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};